export const catalogGroupsQueryKey = () => ["home", "catalog", "groups"]

export const catalogMembersQueryKey = () => ["catalog", "members"]
